import { render, staticRenderFns } from "./VeHrPerformanceForm.vue?vue&type=template&id=955af9aa"
import script from "./VeHrPerformanceForm.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports